import { Injectable /*, Component*/ } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TogetherAuctionDIPFatalErrorComponent } from './../components/dip.fatalerror.component';
import { Observable } from 'rxjs';

@Injectable()
export class UnsavedChangesGuard  {

  canDeactivate(component: any, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (component instanceof TogetherAuctionDIPFatalErrorComponent) {
      alert("Please close the window and retry later.");
      return false;
    }

    return true;
  }
}
